<div class="container">
  <div class="med-text sr-bold page-header">{{ 'ABOUT-US' | translate }}</div>
  <div class="sr-bold">{{ 'ABOUT-US_VISION' | translate }}</div>
  <p>{{ 'ABOUT-US_VISION-CONTENT' | translate }}</p>
  <div class="sr-bold">{{ 'ABOUT-US_MISSION' | translate }}</div>
  <p>{{ 'ABOUT-US_MISSION-CONTENT' | translate }}</p>
  <div class="sr-bold">{{ 'ABOUT-US_SR' | translate }}</div>
  <div [innerHTML]="'ABOUT-US_SR-CONTENT' | translate"></div>
</div>
